import BaseApiService from '../../../services/BaseApiService';
import { DADATA_BASE_ENDPOINT } from '../../../dadata-constants';
import { IDadataFIO, IFIORequest, IPeopleSuggestions } from '../fio-interfaces';

const FIO_URL = '/fio';

class FIOApiService {
  private _httpClient = BaseApiService.createHttpClient(DADATA_BASE_ENDPOINT);

  public async getPeopleList(searchString: string): Promise<string[]> {
    const body: IFIORequest = {
      query: searchString,
    };

    const {
      data: { suggestions },
    } = await this._httpClient.post<IPeopleSuggestions>(FIO_URL, body);

    return suggestions.map(({ value }: IDadataFIO) => value);
  }

  public async getSingleFIO(searchString: string): Promise<IDadataFIO> {
    const body: IFIORequest = {
      query: searchString,
      count: 1,
    };

    const {
      data: { suggestions },
    } = await this._httpClient.post<IPeopleSuggestions>(FIO_URL, body);
    const [single] = suggestions;

    return single;
  }
}

export default FIOApiService;
